import React from "react";
import "./notfound.css";

export default function NotFound() {
  return <div className="layout">NOT FOUND</div>;
}
